import { ModalClose } from "../modalToggle";
const memoClass: string = "js-room-info-memo";
const memoSubmitClass: string = "js-info-memo-submit";
const memoInputClass: string = "c-input--textarea--memo";
const hiddenClass: string = "u-display--none";
document.addEventListener("click", (event: any) => {
  const infoMemoSubmit: HTMLElement = event.target.closest(`.${memoSubmitClass}`)!;
  if(infoMemoSubmit) {
    const input: HTMLInputElement = document.querySelector(`.${memoInputClass}`)!;
    const inputValue: string = input.value;
    const memo: HTMLElement = document.querySelector(`.${memoClass}`)!;
    memo.innerText = inputValue;
    if (inputValue.length !== 0) {
      memo.classList.remove(hiddenClass);
    } else {
      memo.classList.add(hiddenClass);
    }
    ModalClose();
  }
})
